import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import { typeDefs } from './constants';
import template from './selectPicker.vdt';
import { useFormats } from './useFormats';
import { useDisabled } from '../datepicker/useDisabled';
import { useStep } from './useStep';
import { useConfigContext } from '../config';
export var SelectPicker = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SelectPicker, _Component);
  function SelectPicker() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.formats = useFormats();
    _this.disabled = useDisabled(_this.formats);
    _this.step = useStep(_this.disabled, _this.formats);
    _this.config = useConfigContext();
    return _this;
  }
  return SelectPicker;
}(Component);
SelectPicker.template = template;
SelectPicker.typeDefs = typeDefs;